import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProductCart } from 'src/app/models/product-cart';
import { PosAddEditProductReturnManualModalComponent } from 'src/app/shared/pos-add-edit-product-return-manual-modal/pos-add-edit-product-return-manual-modal.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosAddEditProductReturnManualModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) {


  }

  async show(product: ProductCart, isEdit: boolean, confirmAction: (product: ProductCart) => any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(PosAddEditProductReturnManualModalComponent, {
        ignoreBackdropClick: true
      });
      this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`)
      this.modalRef.content.product = product;
      this.modalRef.content.isEdit = isEdit;
      this.modalRef.content.load();
      this.modalRef.content.confirmAction = confirmAction;

      resolve(true);
    })
  };
}
